/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class InputResponsavelVisualizacaoPainelSchema extends Schema {
  readonly name = 'InputResponsavel'

  readonly fieldSet: FieldSet<Responsavel> = {
    visualizacaoCnpjFilial: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
